<template>
  <div class="small">
    <div class="logoandtext large">
      <div class="img-container">
        <img :src="'images/' + cardImg[card_no]" />
      </div>
      <div class="text-container">
        {{ cardState[card_state] }}
        <template v-if="card_state > 0">
          &nbsp;:&nbsp;{{ report === null ? '' : report.icard }} &nbsp;&nbsp;{{
            driver_name
          }}
        </template>
      </div>
    </div>

    <div class="logoandtext large" v-if="card_state > 0">
      <div class="img-container">
        <img :src="'images/' + driverImg[driver_state]" />
      </div>
      <div class="text-container">
        {{ driverState[driver_state] }}
      </div>
      <div class="label_tot guida_color">
        GUIDA TOT. {{ report === null ? '' : minToString(report.guida_tot) }}
      </div>
      <div class="label_tot riposo_color">
        RIPOSO TOT. {{ report === null ? '' : minToString(report.riposo_tot) }}
      </div>
      <div class="label_tot lavoro_color">
        LAVORO TOT. {{ report === null ? '' : minToString(report.lavoro_tot) }}
      </div>
      <div class="label_tot disp_color">
        DISPONIBILE TOT.
        {{ report === null ? '' : minToString(report.disp_tot) }}
      </div>
      <div class="label_tot err_color">
        ERRORE TOT. {{ report === null ? '' : minToString(report.err_tot) }}
      </div>
    </div>
  </div>
</template>

<script>
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
export default {
  name: 'TimetableCard',
  mixins: [UtilityMixin],
  props: {
    report: {
      default: null,
      type: Object,
    },
    lastDataStory: {
      default: null,
      type: Object,
    },
    dataCards: {
      default: null,
      type: Object,
    },
    driver_name: {
      default: '',
      type: String,
    },
    card_no: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {
      startDate: null,
      driver_state: 0,
      card_state: 0,
      driverState: [
        'RIPOSO',
        'DISPONIBILE',
        'LAVORO',
        'GUIDA',
        '',
        '',
        'ERRORE',
        '-',
      ],
      cardImg: ['card1.png', 'card2.png'],
      driverImg: [
        'riposo.png',
        'disp.png',
        'lavoro.png',
        'guida.png',
        '',
        '',
        'error.png',
        '',
      ],
      cardState: ['NON PRESENTE', 'PRESENTE'],
    }
  },

  mounted() {
    const vm = this
    if (vm.lastDataStory && vm.lastDataStory.analogs) {
      if (vm.card_no === 0) {
        vm.driver_state = vm.lastDataStory.analogs.values[3]
        vm.card_state = vm.lastDataStory.analogs.values[2]
      } else {
        vm.driver_state = vm.lastDataStory.analogs.values[6]
        vm.card_state = vm.lastDataStory.analogs.values[5]
      }
    }
    if (vm.report) {
      if (vm.report.guida.length > 0) {
        vm.startDate = vm.newDate(vm.report.guida[0].from)
        return
      }
      if (vm.report.lavoro.length > 0) {
        vm.startDate = vm.newDate(vm.report.lavoro[0].from)
        return
      }
      if (vm.report.riposo.length > 0) {
        vm.startDate = vm.newDate(vm.report.riposo[0].from)
        return
      }
      if (vm.report.disp.length > 0) {
        vm.startDate = vm.newDate(vm.report.disp[0].from)
        return
      }
    }
    vm.startDate = new Date()
  },
  methods: {
    getLast(arry) {
      const vm = this
      if (arry.length > 0) {
        return vm.minToString(arry[arry.length - 1].min)
      }
      return ''
    },
    getTopMin(arry) {
      const vm = this
      if (arry.length > 0) {
        return vm.minToString(arry[0].min)
      }
      return ''
    },
  },
}
</script>
<style scoped>
.small {
  font-size: 10px;
  border-bottom: 1px solid black;
  line-height: 6px;
  font-weight: bold;
}

.large {
  font-size: 14px;
}

.riposo_color {
  color: green;
}

.lavoro_color {
  color: blue;
}

.guida_color {
  color: red;
}

.disp_color {
  color: orange;
}

.err_color {
  color: black;
}
.logoandtext {
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
}
.logoandtext .img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 48px;
}

.logoandtext .img-container img {
  max-height: 32px;
}

.logoandtext .text-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  font-size: 14px;
}

.label_tot {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  font-size: 10px;
}
</style>
